import { HttpStatus } from '../../constants/http-status';

export const isNotFoundException = (statusCode: number) => statusCode === HttpStatus.NOT_FOUND;
